import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'Lib/Hooks/Selectors';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { IncrementRecordRowDefinition, LoadIncrementReading } from 'Components/Worksheets/PlateLoadingWorksheet/types';
import deepEquals from 'Lib/Object/deepEquals';
import { FieldSet, PageSection } from 'Components/Layout';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import IncrementReadingsGridSection from './IncrementReadingsGridSectionBase';
import { Checkbox, Field } from 'Components/Core';

let InitialSeatingReadingSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const recordRows: IncrementRecordRowDefinition[] = useSelector(
    pipe(createWorksheetSelector!('InitialSeatingReading'), (record: LoadIncrementReading) => {
      return [
        {
          ElapsedTime: record.ElapsedTime,
          GaugeReading1: record.GaugeReading1,
          GaugeReading2: record.GaugeReading2,
          GaugeReading3: record.GaugeReading3,
          AverageReading: record.AverageReading,
        },
      ];
    }),
    deepEquals
  );

  return (
    <PageSection heading="Initial Seating Readings">
      <FieldSet>
        <IncrementReadingsGridSection
          name="InitialSeatingReading"
          readingName={() => 'InitialSeatingReading'}
          readings={recordRows}
          initialSeatingReading
        />
        <NamePrefixModifier namePrefix="data.Equipment">
          <Field input={<Checkbox />} name="OffsetIncrementReadingsByInitialSeating" />
        </NamePrefixModifier>
      </FieldSet>
    </PageSection>
  );
};

const InitialSeatingReadingSection = withInjectedProps(InitialSeatingReadingSectionBase);

export { InitialSeatingReadingSection };
export default InitialSeatingReadingSection;
